import React, { useCallback, useContext, useState } from 'react';
import classNames from 'classnames';
import { ShareableLinkMainInfo } from 'models/ShareableLink';
import api from '../../api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import TwoFactorStep from 'components/TwoFactorStep';
import MainInfoStep from 'components/MainInfoStep';
import { MainInfoStepValues } from 'components/MainInfoStep/MainInfoStep.component';
import { TwoFactorStepValues } from 'components/TwoFactorStep/TwoFactorStep.component';

import './ShareableLinkUserForm.styles.scss';

type ShareableLinkUserFormProps = {
  className?: string;
  shareableLinkId: string;
  mainInfo: ShareableLinkMainInfo;
  updateAuthInfo: (
    newMainInfo: ShareableLinkMainInfo,
    newIsPasswordConfirmed?: boolean,
  ) => void;
};

const ShareableLinkUserForm: React.FC<ShareableLinkUserFormProps> = (props) => {
  const { className, shareableLinkId, mainInfo, updateAuthInfo } = props;

  const [showTwoFAStep, setShowTwoFAStep] = useState(false);
  const [twoFAStepEmail, setTwoFAStepEmail] = useState('');

  const classes = classNames('shareable-link-user-form', className);

  const { popServerError } = useContext(PopNotificationsContext);

  const onMainInfoStepSubmit = useCallback(
    async (values: MainInfoStepValues) => {
      const { email, firstName, lastName, companyName } = values;

      try {
        await api.shareableLinks.login(
          shareableLinkId,
          email,
          firstName,
          lastName,
          companyName,
        );

        setTwoFAStepEmail(email);
        setShowTwoFAStep(true);
      } catch (e) {
        popServerError(e);
      }
    },
    [shareableLinkId, popServerError],
  );

  const onTwoFactorStepSubmit = useCallback(
    async (values: TwoFactorStepValues) => {
      const { code } = values;

      try {
        const { data } = await api.shareableLinks.confirmTwoFactor(
          shareableLinkId,
          twoFAStepEmail,
          code,
        );

        updateAuthInfo(data);
      } catch (e) {
        popServerError(e);
      }
    },
    [shareableLinkId, twoFAStepEmail, updateAuthInfo, popServerError],
  );

  return (
    <div className={classes}>
      {showTwoFAStep ? (
        <TwoFactorStep onSubmit={onTwoFactorStepSubmit} />
      ) : (
        <MainInfoStep email={mainInfo?.email} onSubmit={onMainInfoStepSubmit} />
      )}
    </div>
  );
};

export default ShareableLinkUserForm;
